import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Container } from "react-bootstrap";
import { useAuth } from "./components/AuthContext/AuthContext";
import useApis from "./services/useAPI";
import { Button } from "./stories/Buttons/Button";
import ConfirmationModal from "./stories/Modals/ConfirmationModal";
import { logoutUrl, ssoLogoutUrl } from "./utils/constants";
import { BoxArrowInRight } from "react-bootstrap-icons";

/**
 * Handles Logout functionality.
 * also ends the session at the IdP (Single Logout). Without that second
 * part, the IdP still remembers the browser as logged in, so the next
 * "Log in with Boots SSO" would skip straight past the credential prompt.
 * @returns
 */
function Logout() {
  const auth = useAuth();
  const navigate = useNavigate();

  const [modalShow, setModalShow] = useState(false);

  // API hook initialisation
  const { callApi, serverError, message } = useApis(logoutUrl, "POST");

  const handleClick = async () => {
    try {
      await callApi();
    } catch (e) {
      // Handle error if needed
    }
    auth.logout();
    window.location.assign(ssoLogoutUrl);
    navigate("/login");
    auth?.showToast(
      "Logged out",
      "Logged out successfully!",
      "../assets/mhc.png",
      {icon: <BoxArrowInRight />,
      className: auth?.featureFlag && "vh-toaster"},
    );
  };

  const handleModalClose = () => {
    setModalShow(false);
  };

  const handleModalConfirm = async () => {
    setModalShow(false);
    await handleClick();
  };

  return (
    <>
      <Container className="text-center mt-3">
        <Button
          className="logout-btn p-0"
          label="Log out"
          onClick={() => {
            setModalShow(true);
          }}
          variant="outline"
        />
      </Container>
      <ConfirmationModal
        handleClose={handleModalClose}
        handleConfirm={handleModalConfirm}
        heading="Confirm Logout"
        labelOne={"Cancel"}
        labelTwo={"Log out"}
        message="Are you sure you want to log out?"
        show={modalShow}
        vairantOne={"danger"}
        variantTwo={"primary"}
      />
    </>
  );
}

export default Logout;
